import { useQuery } from '@tanstack/react-query';
import { UseFormReturn } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { ApiUserType, apiV1GetOnboardingCategories } from '@/modules/api';

import { OnboardingParamsTool } from '../utils/paramsTool';

export const useQueryOnboardingCategories = ({
  enabled,
  onSuccess,
  form,
}: {
  enabled: boolean;
  onSuccess?: (data: {
    categories: ApiUserType['selected_categories'];
    selectedCategoriesIds: string[];
  }) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) => {
  const { currentUser } = useAccount();

  useQuery({
    enabled: !!currentUser?.deviceId && enabled,
    queryFn: apiV1GetOnboardingCategories,
    onSuccess: ({ categories }) => {
      const selectedCategoriesIdsFromQueryParams =
        OnboardingParamsTool.getParamsList('categories');
      const selectedCategoriesIdFromAPI = categories.reduce((acc, category) => {
        if (category.selected) {
          acc.push(category.id);
        }
        return acc;
      }, [] as string[]);

      const selectedCategoriesIds = Array.from(
        new Set([
          ...selectedCategoriesIdFromAPI,
          ...selectedCategoriesIdsFromQueryParams,
        ]),
      );

      form.setValue('categories', selectedCategoriesIds);
      form.setValue('preloadCategories', categories);

      onSuccess &&
        onSuccess({
          categories,
          selectedCategoriesIds,
        });
    },
    queryKey: ['onboarding_categories'],
    retry(failureCount) {
      if (failureCount < 3) {
        return true;
      }
      return false;
    },
  });
};
